import http from '../../utils/http';
export default {
    /**
     * 通用请求
     *
     * @param {*} data
     * @returns
     */
    HtppRequest(url, method, data, success, fail) {
        return http({
            url: url,
            data: data,
            method: method,
            headers: {
                notShowError: true,
                showLoading: false
            }
        }).then(res => {
            success(res);
        }).catch(err => {
			console.log(err);
            fail(err);
        });
    }

};
